import { getDeviceStateDataValueFromState } from '@/helpers/devices/stateHelper'

export const getStatisticsReadingsFromMeasurements = (
  measurements,
  timestamp
) => {
  if (measurements?.Value?.length) {
    const measurementStatistics = {}
    for (const measurement of measurements.Value) {
      if (measurement?.Value.length) {
        for (const item of measurement.Value) {
          if (item.Key === 'value') {
            measurementStatistics[measurement.Key] = {
              name: measurement.Key,
              value: item.Value,
              timestamp,
            }
          }
        }
      }
    }
    return measurementStatistics
  }

  return null
}

export const getStatisticsReadingsFromSensor = (sensor, timestamp) => {
  if (sensor?.Value?.length) {
    let measurementStatistics = {}
    for (const measurements of sensor.Value) {
      measurementStatistics = {
        ...measurementStatistics,
        ...getStatisticsReadingsFromMeasurements(measurements, timestamp),
      }
    }

    return measurementStatistics
  }

  return null
}

export const getStatisticsReadingsFromSensors = (sensors, timestamp) => {
  if (sensors?.length) {
    let measurementStatistics = {}
    for (const sensor of sensors) {
      measurementStatistics = {
        ...measurementStatistics,
        ...getStatisticsReadingsFromSensor(sensor, timestamp),
      }
    }
    return measurementStatistics
  }

  return null
}

export const getStatisticsReadingsFromState = (state, timestamp) => {
  const sensors = getDeviceStateDataValueFromState(state, 'statistics')
  return getStatisticsReadingsFromSensors(sensors, timestamp)
}
